import axios from 'axios';
import { imageToCanvas } from './imageUtils';
import { ImageFormat } from '@extTypes/image/format';

export const getBase64Format = (base64: string): ImageFormat => {
    let format: ImageFormat = 'png';
    if (base64) {
        const part1 = base64.split(';')[0];
        if (part1) {
            const part2 = part1.split(':')[1];
            if (part2) {
                const mime = part2.split('/')[1];
                if (mime === 'png') format = 'png';
                else if (mime === 'webp') format = 'webp';
                else format = 'jpg';
            }
        }
    }

    // Default mime
    return format;
};

export const uploadBlobToS3 = async (blob: Blob, url: string, mime: string, cacheControl?: string): Promise<void> => {
    return axios.put(url, blob, {
        headers: {
            'Content-Type': mime,
            'Cache-Control': cacheControl ? cacheControl : undefined
        }
    });
};

export const uploadImageToS3 = async (
    image: HTMLCanvasElement | HTMLImageElement | string,
    url: string,
    format: ImageFormat,
    cacheControl?: string,
    convertToWebp?: boolean,
    quality = 80
): Promise<void> => {
    const canvas = await imageToCanvas(image);
    return new Promise((resolve, reject) => {
        // need to convert to jpeg if format is jpg, otherwise the image will be saved as png
        const mime = convertToWebp ? 'image/webp' : 'image/' + format.replace('jpg', 'jpeg');

        // Convert canvas to file
        canvas.toBlob(
            async (blob) => {
                try {
                    await uploadBlobToS3(blob as Blob, url, mime, cacheControl);
                    resolve();
                } catch (error) {
                    window.captureException(error as Error);
                    reject(error);
                }
            },
            mime,
            quality
        );
    });
};
